/**
 * @generated SignedSource<<6f02de6e0db7615b21b70f83984f5da1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentMostPopularTagContent$data = {
  readonly entityId: string;
  readonly " $fragmentType": "contentMostPopularTagContent";
};
export type contentMostPopularTagContent$key = {
  readonly " $data"?: contentMostPopularTagContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentMostPopularTagContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentMostPopularTagContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "ce2fdc6ab00552e00d12e52e4eac8981";

export default node;
